import {ApolloClient} from '@apollo/client'
import {getEmployeeDetailsFromIAM} from '../queries/employeeQuery'
import {getLoginAsInfoFromCookie, deleteCookieByName} from './cookieUtils'

export const getUserProfileFromCitrixId = async (
  citrixId: string,
  client: ApolloClient<any>
) => {
  try {
    const userResponse = await client.query({
      fetchPolicy: 'network-only',
      query: getEmployeeDetailsFromIAM,
      variables: {empId: citrixId},
    })

    if (userResponse?.data?.getEmployeeDetailsFromIAM) {
      const employeeInfo = userResponse.data.getEmployeeDetailsFromIAM
      return {
        employeeId: employeeInfo?.sixtId || citrixId,
        employeeEmail: employeeInfo?.email,
        employeeName: employeeInfo.displayName,
      }
    }
  } catch (ex) {
    console.warn('Error fetching user profile:', ex)
    return null
  }
}

export const logoutFromLoginAs = () => {
  const loginAsUserInfo = getLoginAsInfoFromCookie()
  if (loginAsUserInfo.citrixId) {
    deleteCookieByName('loginAs')
    deleteCookieByName('sfid_dev_loginas')
    window.location.href = `/view-employee/${loginAsUserInfo.citrixId}`
  }
}
